export default {
  common: {
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    loading: "Loading…",
    saving: "Saving…",
    retry: "Retry",
    back: "Back",
    next: "Next",
    yes: "Yes",
    no: "No",
    all: "All",
    none: "None",
    noData: "No data",
    error: "An error occurred.",
    seeMore: "See more",
    seeDetail: "See detail",
  },
};
